var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrowContactUs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 9,
    viewBox: "0 0 37 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.4266 9L36.1157 5.15834L36.4141 4.8335L36.1157 4.50865L32.4266 0.666994L31.8027 1.31669L34.7458 4.38154L0.998783 4.38154L0.998783 5.28546L34.7458 5.28546L31.8027 8.35031L32.4266 9Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowContactUs);
export default __webpack_public_path__ + "static/media/RightArrowContactUS.76c31c93a8b92279853d1f7b8a767083.svg";
export { ForwardRef as ReactComponent };